import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { NotificationsApiService } from 'app/view/notifications/services/notifications-api.service';
import { NotificationsActions } from 'app/view/notifications/store/notifications.actions';
import { firstValueFrom } from 'rxjs';
import { NotificationDTO } from '../data/NotificationDTO';

@Injectable({
  providedIn: 'root'
})
export class NotificationsFacadeService {
  constructor(private readonly notificationsApiService: NotificationsApiService, private store: Store) {
  }

  public async markAsRead(notifications: NotificationDTO[]): Promise<void> {
    const unreadNotifications = notifications.filter(n => !n.hasBeenRead);
    const notificationIds = unreadNotifications.map(n => n.id);

    this.store.dispatch(new NotificationsActions.setHasUnreadNotifications(false))
    if (notificationIds.length > 0) {
      await firstValueFrom(this.notificationsApiService.markNotificationsAsRead(notificationIds));
    }
  }
}
